import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { NotFound } from 'src/components/common/notFound/NotFound';
import { DocumentTitle } from 'src/components/documentTitle/DocumentTitle';

import { variantPersistedQueriesRouteConfig } from '../../routes';

import { VariantPersistedQueryListPage } from './persistedQueryListPage/PersistedQueryListPage';

// TODO: internal graph linking to handle variant/graph level persisted queries so
// we can render the existing pages here
export const VariantPersistedQueriesLayout = () => {
  return (
    <Switch>
      <Route
        exact
        path={variantPersistedQueriesRouteConfig.definition}
        render={() => (
          <DocumentTitle title="Home">
            <VariantPersistedQueryListPage />
          </DocumentTitle>
        )}
      />
      <NotFound />
    </Switch>
  );
};
